    (function () {
      var root = document.querySelector('[data-vk-pair]');
      if (!root) return;
      var btn = root.querySelector('[data-vk-add]');
      if (!btn) return;
      var msg = root.querySelector('[data-vk-msg]');
      btn.addEventListener('click', function () {
        btn.disabled = true;
        var label = btn.textContent;
        btn.textContent = 'Adding...';
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(btn.dataset.vkId), quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function () {
            btn.textContent = 'Added to your basket';
            document.dispatchEvent(new CustomEvent('rebuy:cart.change'));
            if (window.Rebuy && window.Rebuy.SmartCart && window.Rebuy.SmartCart.open) {
              window.Rebuy.SmartCart.open();
            } else if (window.location.pathname.indexOf('/cart') === -1) {
              if (msg) { msg.hidden = false; msg.textContent = 'Open your basket when you are ready to check out.'; }
            }
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = label;
            if (msg) { msg.hidden = false; msg.textContent = 'That did not add. Please try again or message us on WhatsApp.'; }
          });
      });
    })();
